import styled from 'styled-components';

import { colors } from '@theme';

export const ModalWrap = styled.div`
  width: 480px;
  height: auto;
  background-color: #1c1c1c;

  padding: 70px 76px;
`;

export const Title = styled.h3`
  font-family: SchnyderWideM;
  font-size: 32px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: -0.39px;
  text-align: center;
  margin-bottom: 36px;

  color: ${colors['error-red']};
`;

export const ErrorText = styled.p`
  font-family: GTAmerica;
  font-size: 16px;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  margin-bottom: 36px;

  color: ${colors['light-peach']};
`;

export const OrText = styled.p`
  font-family: GTAmerica;
  font-size: 16px;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  margin-bottom: 36px;

  color: ${colors['light-peach']};
`;

export const ButtonGrid = styled.div`
  font-family: GTAmerica;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 64px;
`;

const Button = styled.button`
  height: 100%;
  width: 100%;

  font-family: GTAmerica;
  font-size: 16px;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: normal;
  text-align: center;

  border: solid 1px ${colors['light-peach']};
  transition: all 0.5s cubic-bezier(0.6, 0.2, 0.15, 0.95);
`;

export const DarkButton = styled(Button)`
  color: ${colors['black']};
  background-color: ${colors['light-peach']};
  border: solid 1px ${colors['light-peach']};

  &:hover {
    color: ${colors['light-peach']};
    background-color: ${colors['desert-rock']};
    border: solid 1px ${colors['desert-rock']};
  }
`;
export const LightButton = styled(Button)`
  color: ${colors['light-peach']};
  background-color: transparent;

  &:hover {
    color: ${colors['black']};
    background-color: ${colors['light-peach']};
    border: solid 1px ${colors['light-peach']};
  }
`;

export const ClipboardBox = styled.a`
  position: relative;
  width: 100%;
  height: 64px;
  margin-bottom: 30px;
  padding: 0 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: solid 1px rgba(228, 223, 212, 0.3);

  &:hover {
    border: solid 1px ${colors['light-peach']};
  }

  span {
    font-family: GTAmerica;
    font-size: 22px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.09;
    letter-spacing: -0.83px;
    text-align: center;

    color: ${colors['light-peach']};
  }

  svg {
    position: absolute;
    right: 24px;
    width: 15px;
    height: 15px;
    stroke: ${colors['light-peach']};
  }
`;
